<template>
  <div class="container">
    <Nav></Nav>
    <div class="warp">
      <img
        style="width:100%;height:300px"
        src="../assets/images/solution/medSolution.png"
        alt=""
      />
    </div>
    <div class="wrap-nav" style="width:100%;background-color: #fbfbfb;">
      <div class="nav">
        <div
          :class="{ 'nav-item': true, active: pageInd == 1 }"
          @click="changePage(1)"
        >
          基于行业整个与法律法规的解决方案
        </div>
        <div
          :class="{ 'nav-item': true, active: pageInd == 2 }"
          @click="changePage(2)"
        >
          基于市场热点的解决方案
        </div>
        <div
          :class="{ 'nav-item': true, active: pageInd == 3 }"
          @click="changePage(3)"
        >
          定制化、模块化系统建设
        </div>
      </div>
    </div>
    <!-- page 1 -->
    <div v-show="pageInd == 1" class="m1">
      <div class="wrap text">
        <p>
          针对行业从业人员管理的一体化解决方案，依据管理部门的统筹管理要求，设计从业人员信息化管理平台，设计从业人员职业技能考核标准，实现全网、全行业统一标准的行业人才信息库。
        </p>
        <p>
          统筹管理要求统一标准、统一考核题库、统一证书电子编码、统一联网查询等。
        </p>
      </div>
      <div class="wrap img-box">
        <img src="../assets/images/solution/mind.png" alt="" />
      </div>
      <div class="bg bg1">
        <div class="titleimg-box">
          <img src="../assets/images/solution/logo11.png" alt="" />
        </div>
        <div class="main1 wrap">
          <div class="item">
            <img src="../assets/images/solution/item11.png" alt="" />
            <div class="title">人员管理与联网查询系统</div>
            <ul>
              <li>建设互联互通管理系统</li>
              <li>建立标准考核培训体系</li>
              <li>全国统一联网查询</li>
            </ul>
          </div>
          <div class="item">
            <img src="../assets/images/solution/item12.png" alt="" />
            <div class="title">统一题库</div>
            <ul>
              <li>组建行业专家库</li>
              <li>远程命题、审题</li>
              <li>试题入库</li>
              <li>智能抽题组卷</li>
            </ul>
          </div>
          <div class="item">
            <img src="../assets/images/solution/item13.png" alt="" />
            <div class="title">技能鉴定平台</div>
            <ul>
              <li>提供无纸化考核服务</li>
              <li>支持大规模在线考核</li>
              <li>全国考核无缝对接</li>
              <li>鉴定数据实时上传</li>
            </ul>
          </div>
          <div class="item">
            <img src="../assets/images/solution/item14.png" alt="" />
            <div class="title">教育培训资源库</div>
            <ul>
              <li>在线报名学习服务</li>
              <li>考前练习刷题服务</li>
              <li>培训数据实时上传</li>
            </ul>
          </div>
        </div>
        <div class="swiper-box wrap">
          <swiper :options="swiperOption1">
            <swiper-slide
              ><img src="../assets/images/solution/banner11.png" />
              <p>全国统一联网查询</p></swiper-slide
            >
            <swiper-slide
              ><img src="../assets/images/solution/banner12.png" />
              <p>互联互通管理系统</p></swiper-slide
            >
            <swiper-slide
              ><img src="../assets/images/solution/banner13.png" />
              <p>教育培训资源库</p></swiper-slide
            >
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
          </swiper>
        </div>
      </div>
      <div class="bg bg2">
        <div class="titleimg-box">
          <img src="../assets/images/solution/logo12.png" alt="" />
        </div>
        <div class="wrap main2">
          <img
            class="left-img"
            src="../assets/images/solution/item2-img.png"
            alt=""
          />
          <div class="right-txt">
            <div v-for="item in pmList">
              <img src="../assets/images/solution/pmList-img.png" alt="" />
              <div class="title">{{ item.title }}</div>
              <div class="msg">{{ item.msg }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="bg bg3">
        <div class="titleimg-box">
          <img src="../assets/images/solution/logo13.png" alt="" />
        </div>
        <div class="wrap img-box">
          <img
            style="width:800px;"
            src="../assets/images/solution/main11.png"
            alt=""
          />
          <img
            style="width:400px;margin-top:80px;height:350px;"
            src="../assets/images/solution/main12.png"
            alt=""
          />
        </div>
        <div class="wrap img-box">
          <div>
            <img
              style="width:600px;"
              src="../assets/images/solution/main13.png"
              alt=""
            />
            <p>
              （食品安全教育培训小程序）
            </p>
          </div>
          <div>
            <img
              style="width:600px;"
              src="../assets/images/solution/main14.png"
              alt=""
            />
            <p>
              （特食抽查考核小程序）
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- page 2 -->
    <div v-show="pageInd == 3" class="m2">
      <div class="bg1">
        <div class="wrap text">
          <p>
            定制化行业管理解决方案是指通过与行业/企业管理部门（政府单位、行业协会、企业、院校等）深入沟通理解行业/企业管理要求、解决行业/企业的管理痛点，结合先进技术手段，实现行业管理的互联网化、智能化。
          </p>
          <p>
            定制化行业管理解决方案具备行业管理特色，反映主管部门的管理思想，并充分考虑从业人员的文化知识水平、职业技能掌握程度、行业特殊要求等，提供诸如人脸识别、活体检测、智能测评、iPEC智能课件等服务。
          </p>
          <p>
            为便于管理和使用，平台产品提供多样化选择，支持PC端、移动端（APP、微信小程序等）应用，充分利用从业人员碎片化时间，随时随地进行学习，培养用户“终身学习”的职业习惯。
          </p>
        </div>
        <div class="wrap item1-box">
          <swiper :options="swiperOption2">
            <swiper-slide v-for="(item, index) in m2List1" :key="index">
              <div class="item1">
                <img class="logo" :src="item.logo" alt="" />
                <p class="title">{{ item.title }}</p>
                <span class="text2">{{ item.msg }}</span>

                <img class="btm-img" :src="item.img" alt="" />
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>
      <div class="bg2">
        <div class="titleimg-box">
          <img src="../assets/images/solution/logo22.png" alt="" />
        </div>
        <div class="bg2-box">
          <img src="../assets/images/solution/m2222.png" alt="" />
          <p>（全国道路运输驾驶员继续教育网络平台）</p>
        </div>
      </div>
      <div class="bg3">
        <div class="titleimg-box">
          <img src="../assets/images/solution/logo23.png" alt="" />
        </div>
        <div class="customizend-box">
          <swiper :options="swiperOption3">
            <swiper-slide v-for="(item, index) in m2List2" :key="index">
              <div class="item1">
                <p class="title">{{ item.title }}</p>

                <img class="btm-img" :src="item.img" alt="" />
              </div>
            </swiper-slide>
          </swiper>
          <div class="swiper-pagination"></div>
        </div>
      </div>
    </div>
    <!-- page 3 -->
    <div v-show="pageInd == 2" class="m3">
      <div class="bg1">
        <div class="titleimg-box">
          <img src="../assets/images/solution/logo31.png" alt="" />
        </div>
        <div class="bg1-box">
          <div class="wrap bg1-main">
            <img src="../assets/images/solution/m1leftimg.png" alt="" />
            <div>
              <p>
                行业与行业从业人员处于社会组织自行评价阶段，特别是人社部关于职业资格清单目录清理以来，大量的行业职业资格取消，而行业用人需求中需要大量经过认证的从业人员。
              </p>
              <br />
              <p>
                通过权威的行业协会推行行业培训合格证书，紧密结合职业资格标准与新技术、新方法、新理论、新材料等，通过一系列技术手段不断提高行业从业人员技能水平，通过考核后颁发行业培训合格证书。
              </p>
              <br />
              <p>
                通过举办行业大赛、申报人社部职业技能竞赛来提升行业培训合格证书的含金量。基于考核基础，向人社部、教育部申请成为社会培训评价组织，进一步提升行业影响力和权威性。
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="bg2">
        <div class="wrap bg2-main">
          <img src="../assets/images/solution/m3m2i1.png" alt="" />
          <img src="../assets/images/solution/m3m2i2.png" alt="" />
        </div>
      </div>

      <div class="bg3">
        <div class="wrap bg3-box">
          <img src="../assets/images/solution/m3m3i1.png" alt="" />
          <img src="../assets/images/solution/m3m3i2.png" alt="" />
        </div>
      </div>
      <div class="bg4">
        <div class="titleimg-box">
          <img src="../assets/images/solution/logo41.png" alt="" />
        </div>
        <div class="wrap bg4-box1">
          <div>
            <img src="../assets/images/solution/m3m4i1.png" alt="" />
            <img src="../assets/images/solution/m3m4i2.png" alt="" />
          </div>
          <div>
            <img src="../assets/images/solution/m3m4i3.png" alt="" />
          </div>
        </div>
        <div class="wrap bg4-box2">
          <img src="../assets/images/solution/m3m4i4.png" alt="" />
          <img src="../assets/images/solution/m3m4i5.png" alt="" />
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Nav from '@/components/topNav'
import Footer from '@/components/footer'
import 'swiper/dist/css/swiper.css' /// /这里注意具体看使用的版本是否需要引入样式，以及具体位置。
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  components: {
    Nav,
    Footer,
    swiper,
    swiperSlide
  },
  data () {
    return {
      pageInd: this.$route.query.page || 1,
      swiperOption1: {
        effect: 'coverflow',
        grabCursor: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        coverflowEffect: {
          rotate: 0,
          stretch: 0,
          depth: 0,
          modifier: 1,
          slideShadows: false
        },
        autoplay: 3000,
        speed: 1000,
        loop: true,
        slidesPerView: 3,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      swiperOption2: {
        slidesPerView: 'auto',
        autoplay: {
          delay: 3000
        },
        speed: 1000,
        loop: true,
        slidesPerView: 4
      },
      swiperOption3: {
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
		  },
		  speed: 700,
		  allowTouchMove: false,
		  lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 3
		  },
		  centeredSlides: true,
		  slidesOffsetBefore: 40,
		  loop: true,
		  slidesPerView: 'auto',

		  pagination: {
          el: '.swiper-pagination',
          clickable: true,
          renderBullet: function (index, className) {
            return '<div class="' + className + '"><span></span><i></i></div>'
          }
		  },
		  navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
		  }
      },
      pmList: [
        {
          title: '培训管理',
          msg:
            '建立托育服务行业从业人员培训信息管理模块，实现托育从业人员的培训信息统筹管理，全面了解和掌握从业人员的职业技能水平与服务水平。'
        },
        {
          title: '标准培训',
          msg:
            '建立托育行业专家信息库，通过行业权威专家建立标准培训大纲和考核大纲。建立统一题库，各地可以调用，实现培训考核的标准化、规范化。'
        },
        {
          title: '全流程监控',
          msg:
            '实现关键流程、关键节点的审核管理，实现全流程监控，比如培训全流程、考核全流程。同时所有数据留档入库，可提供培训考核的流程追溯。'
        },
        {
          title: '公开查询',
          msg:
            '针对完成培训、并考核通过的从业人员，系统生成唯一的电子编码，同时开放公众查询端口，通过该电子编码可查询从业的详细培训信息。'
        }
      ],
      m2List1: [
        {
          logo: require('../assets/images/solution/m2i0.png'),
          title: '专属客服',
          msg: '客服团队解决今后问题，提供400电话、微信、qq等客服渠道。',
          img: require('../assets/images/solution/m2inb1.png')
        },
        {
          logo: require('../assets/images/solution/m2i1.png'),
          title: '模块化流程',
          msg:
            '可以根据不同省份、地区的管理特点搭建符合属地管理的业务流程，整个过程如同搭建积木，快速建立。',
          img: require('../assets/images/solution/m2inb2.png')
        },
        {
          logo: require('../assets/images/solution/m2i2.png'),
          title: '多因子鉴定',
          msg:
            '等坚定技术手段供选择，且对于坚定参数比如时间、次数等都可以灵活配置。',
          img: require('../assets/images/solution/m2inb3.png')
        },
        {
          logo: require('../assets/images/solution/m2i3.png'),
          title: '表单式定制',
          msg: '提供高达100+配置选项，用户选填表单即可完成系统流程的定制化工作。',
          img: require('../assets/images/solution/m2inb4.png')
        }, {
          logo: require('../assets/images/solution/m2i4.png'),
          title: '智能测评',
          msg: '对标职业技能标准，提供针对用户个人的智能测评服务，提供多维度的测评数据指标',
          img: require('../assets/images/solution/m2inb5.png')
        }, {
          logo: require('../assets/images/solution/m2i5.png'),
          title: '智能模块',
          msg: '依实际需求，利用现有成熟模块，可快速生成PC端、移动端应用。',
          img: require('../assets/images/solution/m2inb6.png')
        }, {
          logo: require('../assets/images/solution/m2i6.png'),
          title: '智能课件',
          msg: '提供IPEC智能课件服务，快速高效批量化生产课件内容。',
          img: require('../assets/images/solution/m2inb7.png')
        }
      ],
      m2List2: [
        {
          title: '交通运输企业安全教育公共服务系统',
          img: require('../assets/images/solution/jtindex.png')
        },
        {
          title: '中国中铁技能人才信息管理系统',
          img: require('../assets/images/solution/ztindex.png')
        },
        {
          title: '注册安全工程师在线继续教育网络平台',
          img: require('../assets/images/solution/zjjindex.png')
        }
      ]
    }
  },
  mounted () {
    // console.log(this.$route.query.page, 'query')
    this.pageInd = this.$route.query.page
  },
  methods: {
    changePage (pageInd) {
      this.pageInd = pageInd
    }
  }
}
</script>

<style lang="less" scoped>
.bg {
  width: 100%;
  margin: auto;
}
// .container{
//   width: 100%;
// }
.wrap {
  width: 1200px;
  margin: auto;
}
.wrap-nav{
  width: 100%;
  height: 60px;
  background-color: #F0F0F0;
}
.text {
  display: block;
  width: 1200px;
  height: 98px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  line-height: 38px;
  text-indent: 40px;
  margin:60px auto 0px;
}
// 二级title img
.titleimg-box {
  padding: 60px 0 40px 0;
  img {
    display: block;
    margin: auto;
  }
}
.nav {
  display: flex;
  justify-content: space-evenly;
  margin: auto;
  width: 1000px;
  margin-bottom: 64px;
   background-color: #fbfbfb;
  .nav-item {
    // width: 430px;
    height: 60px;
    line-height: 60px;
    text-align: center;
     background-color: #fbfbfb;
    cursor: pointer;
    color: #333333;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
  }
  .active {
   color: #B00000;
   background-image: url('../assets/images/solution/nav-top1.png');
   background-size: 124px 8px;
   background-repeat: no-repeat;
   background-position: center 50px;
  }
}
.img-box {
  margin-top: 60px;
  img {
    display: block;
    margin: auto;
    margin-bottom: 40px;
  }
}
.m1 {
  .bg1 {
    background: 100% url(../assets/images/solution/bg1.png);
    height: auto;
    .main1 {
      background: #fff;
      display: flex;
      padding: 50px 0;
      box-shadow: 0px 0px 24px 0px rgba(85, 85, 85, 0.1);
      border-radius: 5px;
      .item {
        flex: 1;
        border-left: solid 1px #ebebeb;
        &:first-child {
          border-left: none;
        }
        img {
          display: block;
          margin: auto;
          // padding-top: 44px;
        }
        .title {
          height: 40px;
          line-height: 40px;
          font-size: 25px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #333333;
          margin-bottom: 10px;
          text-align: center;
          padding: 25px 0;
        }
        ul {
          // list-style: none;
          padding-left: 85px;
          padding-top: 10px;
          text-align: left;

          li {
            margin-bottom: 10px;
            font-size: 18px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #666666;
          }
        }
      }
    }
    .swiper-box {
      position: relative;
      padding: 50px 0;
      img {
        display: block;
        width: 350px;
        margin: auto;
      }
      p {
        text-align: center;
      }
    }
  }
  .bg2 {
    background: 100% url(../assets/images/solution/bg2.png);
    height: auto;
    padding-bottom: 30px;
    .main2 {
      position: relative;
      display: flex;
      .left-img {
        display: block;
        width: 700px;
        z-index: 999;
      }
      .right-txt {
        position: absolute;
        box-shadow: 0px 0px 32px 0px rgba(85, 85, 85, 0.18);
        padding: 25px 30px 0 65px;
        background: #fff;
        height: 380px;
        width: 500px;
        right: 50px;
        top: 46px;
        .title {
          display: inline;
          font-size: 20px;
          font-weight: bold;
          padding-left: 2px;
          color: #b00000;
        }
        .msg {
          margin-bottom: 15px;
          font-size: 12px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #666666;
          line-height: 20px;
        }
      }
    }
  }
  .bg3 {
    background: 100% url(../assets/images/solution/bg3.png);
    height: auto;
    padding-bottom: 80px;
    .img-box {
      margin-top: 0;
      display: flex;
      img {
        margin-bottom: 10px;
      }
      p {
        text-align: center;
      }
    }
  }
}
.m2 {
  .bg1 {
    background: #f9f9fa;
    margin-top: -110px;
    padding-top: 110px;
    padding-bottom: 50px;
    .text {
      height: auto;
      margin-bottom: 30px;
    }
    .item1-box {
      height: 300px;
      cursor: pointer;
      &:hover {
        transform: scale(1);
      }
      .item1 {
        border-left: #f9f9fa 14px solid;
        border-left: #f9f9fa 14px solid;
        width: 100%;
        height: 100%;
        background: #fff;
        .logo {
          width: 60px;
          height: 80px;
          display: block;
          padding-top: 20px;
          margin: auto;
        }
        .title {
          font-size: 26px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #333333;
          text-align: center;
          padding: 14px 0;
        }
        .text2 {
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: 500;
          color: #666666;
          width: 80%;
          margin: auto;
          display: block;
          height: 120px;
        }
        .btm-img {
          width: 50px;
          height: 60px;

          display: block;
          margin: auto;
          padding-bottom: 10px;
        }
      }
    }
  }
  .bg2 {
    background-image: url(../assets/images/solution/bg22.png);
    height: auto;
    .bg2-box {
      img {
        display: block;
        margin: auto;
      }
      p {
        display: block;
        text-align: center;
        padding-bottom: 20px;
      }
    }
  }
  .bg3 {
    background-image: url(../assets/images/solution/bg3.png);
    height: auto;
  }
}
.m3 {
  .bg1 {
    background-image: url(../assets/images/solution/bg31.png);
    padding-bottom: 40px;
    .bg1-main {
      box-sizing: border-box;
      padding: 40px;
      display: flex;
      background-image: url(../assets/images/solution/m3m1bg11.png);
      background-repeat: no-repeat;
      div {
        box-sizing: border-box;
        padding: 40px;
        margin-left: -90px;
        margin-top: 8px;
        width: 530px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #303039;
        line-height: 20px;
        background-image: url(../assets/images/solution/m3m1bg12.png);
        background-repeat: no-repeat;
        background-size: 100% 100%;
        p {
          text-indent: 40px;
          line-height: 1.5;
        }
      }
    }
  }
  .bg2 {
    padding: 30px 0;
    .bg2-main {
      padding: 25px 5px;
      background-image: url(../assets/images/solution/m3m3bg2.png);
      display: flex;
    }
  }
  .bg3 {
    background-image: url(../assets/images/solution/m3m3bg3.png);
    padding: 25px 0;
    .bg3-box {
      display: flex;
    }
  }
  .bg4 {
    .bg4-box1 {
      display: flex;
      margin-bottom: 30px;
    }
    .bg4-box2 {
      margin-bottom: 80px;
    }
  }
}
.customizend-box{
  position: relative;
  .btm-img{
    width: 100%;
  }
  .title{
    border-bottom: 1px solid #B00000;
    text-align: center;
    color: #B00000;
    font-size: 17px;
    font-weight: 700;
  }
  .swiper-container {
	    padding-bottom:40px;
    }

    .swiper-slide {
	    width:978px;
		transition-timing-function:linear;
    }

	.swiper-slide img{
		width:100%;
		border-radius: 4px;}

  .swiper-pagination{
width: 179px;
    left: 50%;
    bottom: 29px;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/solution.vue